<svg width="1rem" height="1rem" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.371657 5.7264C-0.691068 4.63958 0.756461 2.78939 1.81947 3.8767L4.49075 6.60899L10.1475 0.361554C11.178 -0.77162 12.6854 1.01961 11.6548 2.15295L4.54963 10L0.371657 5.7264Z" />
</svg>
